<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6.85714" fill="white" />
    <path d="M16.6666 8.66675L10.25 15.3334L7.33331 12.3031" stroke="currentColor" stroke-width="1.33333" />
  </svg>
</template>
